import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export default function DialogBody({ className = '', ...props }) {
  return <div className={twMerge(classes.dialogBody, className)} {...props} />;
}
